/**
 * Los tres pasos de la compra, con el actual marcado.
 *
 * Es una lista ordenada y no una fila de `div`: para quien no ve la pantalla,
 * "paso 2 de 3" es la informacion, y sin una lista no hay de donde sacarla. El
 * separador va oculto porque es una linea decorativa entre dos pasos.
 */
import { Icono } from '../comunes/Icono';

/**
 * "Datos y despacho" no entra en una sola linea junto a los otros dos pasos
 * en telefonos como el iPhone 12 Pro (390px): con las tres etiquetas
 * completas, `.pasos` recien deja de envolver a los ~414px. `corto` es la
 * version que se muestra en ese ancho en vez de partir la fila en dos.
 */
const PASOS = [
  { texto: 'Carro' },
  { texto: 'Datos y despacho', corto: 'Datos' },
  { texto: 'Pago' },
] as const;

export function PasosCompra({ actual }: { actual: number }) {
  return (
    <ol className="pasos" aria-label="Progreso de la compra">
      {PASOS.map((paso, indice) => {
        const numero = indice + 1;
        const hecho = numero < actual;
        const activo = numero === actual;

        return (
          <li className="paso-item" key={paso.texto}>
            {indice > 0 ? <span className="paso-sep" aria-hidden="true" /> : null}

            <span className={`paso${hecho ? ' hecho' : activo ? ' activo' : ''}`}>
              <span className="n" aria-hidden="true">
                {hecho ? <Icono nombre="check" /> : numero}
              </span>
              {'corto' in paso ? (
                <>
                  <span className="paso-texto-largo">{paso.texto}</span>
                  <span className="paso-texto-corto">{paso.corto}</span>
                </>
              ) : (
                paso.texto
              )}
              {activo ? <span className="solo-lectores"> (paso actual)</span> : null}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
